export function assertDefined(value: unknown, error?: string | (() => Error)): asserts value {
  if (value === undefined || value === null) {
    if (typeof error === "function") {
      throw error();
    } else {
      throw new Error(error || "value must be defined");
    }
  }
}

export const isEnumValue =
  <T extends { [s: string]: unknown }>(e: T) =>
  (token: unknown): token is T[keyof T] =>
    Object.values(e).includes(token as T[keyof T]);
